<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <TriggerForm :id="trigger_id" @updated="$router.push({name: 'trigger.index'})"/>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TriggerForm from "@/pages/triggers/components/TriggerForm";

export default {
  name: "Form",
  components: {LayoutGradient, TriggerForm},
  data() {
    return {
      trigger_id: null
    }
  },
  computed: {
    pageTitle() {
      if (this.trigger_id) return this.$t('trigger.form.titulo_pagina.editar')
      return this.$t('trigger.form.titulo_pagina.criar')
    }
  },
  created() {
    if (this.$route.params.id) {
      this.trigger_id = this.$route.params.id
    }
  }
}
</script>

<style scoped>
</style>
